// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iu7m","content":"styles_content__-qvp-"};